export const RETRO_FORM_CAT_CUSTOM_FIELD = 'RETROSPECTIVE_CATEGORY';
export const RETRO_FORM_GUIDING_QUES_CUSTOM_FIELD = 'RETROSPECTIVE_GUIDING_QUESTIONS'
